__turbopack_context__.v({
  "baseUrlChip": "ApiDocsPage-module__zrwB-G__baseUrlChip",
  "container": "ApiDocsPage-module__zrwB-G__container",
  "emptyState": "ApiDocsPage-module__zrwB-G__emptyState",
  "layout": "ApiDocsPage-module__zrwB-G__layout",
  "main": "ApiDocsPage-module__zrwB-G__main",
  "placeholder": "ApiDocsPage-module__zrwB-G__placeholder",
  "placeholderStats": "ApiDocsPage-module__zrwB-G__placeholderStats",
  "requestPanel": "ApiDocsPage-module__zrwB-G__requestPanel",
  "rpDescription": "ApiDocsPage-module__zrwB-G__rpDescription",
  "rpExecuteBtn": "ApiDocsPage-module__zrwB-G__rpExecuteBtn",
  "rpHeader": "ApiDocsPage-module__zrwB-G__rpHeader",
  "rpInput": "ApiDocsPage-module__zrwB-G__rpInput",
  "rpMethod": "ApiDocsPage-module__zrwB-G__rpMethod",
  "rpParamInfo": "ApiDocsPage-module__zrwB-G__rpParamInfo",
  "rpParamMeta": "ApiDocsPage-module__zrwB-G__rpParamMeta",
  "rpParamName": "ApiDocsPage-module__zrwB-G__rpParamName",
  "rpParamRow": "ApiDocsPage-module__zrwB-G__rpParamRow",
  "rpParams": "ApiDocsPage-module__zrwB-G__rpParams",
  "rpPath": "ApiDocsPage-module__zrwB-G__rpPath",
  "rpRequired": "ApiDocsPage-module__zrwB-G__rpRequired",
  "rpResponseCode": "ApiDocsPage-module__zrwB-G__rpResponseCode",
  "rpResponseHeader": "ApiDocsPage-module__zrwB-G__rpResponseHeader",
  "rpSection": "ApiDocsPage-module__zrwB-G__rpSection",
  "rpSectionTitle": "ApiDocsPage-module__zrwB-G__rpSectionTitle",
  "rpSmallBtn": "ApiDocsPage-module__zrwB-G__rpSmallBtn",
  "rpStatusBadge": "ApiDocsPage-module__zrwB-G__rpStatusBadge",
  "rpStatusErr": "ApiDocsPage-module__zrwB-G__rpStatusErr",
  "rpStatusOk": "ApiDocsPage-module__zrwB-G__rpStatusOk",
  "rpSummary": "ApiDocsPage-module__zrwB-G__rpSummary",
  "rpUrlActions": "ApiDocsPage-module__zrwB-G__rpUrlActions",
  "rpUrlBox": "ApiDocsPage-module__zrwB-G__rpUrlBox",
  "rpUrlHeader": "ApiDocsPage-module__zrwB-G__rpUrlHeader",
  "searchClear": "ApiDocsPage-module__zrwB-G__searchClear",
  "searchIcon": "ApiDocsPage-module__zrwB-G__searchIcon",
  "searchInput": "ApiDocsPage-module__zrwB-G__searchInput",
  "sidebar": "ApiDocsPage-module__zrwB-G__sidebar",
  "sidebarEmpty": "ApiDocsPage-module__zrwB-G__sidebarEmpty",
  "sidebarGroupCount": "ApiDocsPage-module__zrwB-G__sidebarGroupCount",
  "sidebarGroupTitle": "ApiDocsPage-module__zrwB-G__sidebarGroupTitle",
  "sidebarItem": "ApiDocsPage-module__zrwB-G__sidebarItem",
  "sidebarItemActive": "ApiDocsPage-module__zrwB-G__sidebarItemActive",
  "sidebarMethod": "ApiDocsPage-module__zrwB-G__sidebarMethod",
  "sidebarNav": "ApiDocsPage-module__zrwB-G__sidebarNav",
  "sidebarPath": "ApiDocsPage-module__zrwB-G__sidebarPath",
  "skeleton": "ApiDocsPage-module__zrwB-G__skeleton",
  "skeletonLayout": "ApiDocsPage-module__zrwB-G__skeletonLayout",
  "skeletonMain": "ApiDocsPage-module__zrwB-G__skeletonMain",
  "skeletonShimmer": "ApiDocsPage-module__zrwB-G__skeletonShimmer",
  "skeletonSidebar": "ApiDocsPage-module__zrwB-G__skeletonSidebar",
  "tagBtn": "ApiDocsPage-module__zrwB-G__tagBtn",
  "tagBtnActive": "ApiDocsPage-module__zrwB-G__tagBtnActive",
  "tagFilters": "ApiDocsPage-module__zrwB-G__tagFilters",
  "title": "ApiDocsPage-module__zrwB-G__title",
  "topBar": "ApiDocsPage-module__zrwB-G__topBar",
  "topBarIcon": "ApiDocsPage-module__zrwB-G__topBarIcon",
  "topBarLeft": "ApiDocsPage-module__zrwB-G__topBarLeft",
  "topBarRight": "ApiDocsPage-module__zrwB-G__topBarRight",
  "topBarSearch": "ApiDocsPage-module__zrwB-G__topBarSearch",
  "topBarTags": "ApiDocsPage-module__zrwB-G__topBarTags",
  "topBarTitle": "ApiDocsPage-module__zrwB-G__topBarTitle",
});
